export default __webpack_public_path__ + "static/media/profile-pic.2ead34f1.JPG";